import Env from 'src/environmentVariables/EnvironmentVariables';

export const WEBSOCKET_URL = Env.dlobWsServerToUse;
export const WS_TIMEOUT_MS = 5000;
export const FALLBACK_COOLDOWN_MS = 60000;
export const TAB_INACTIVE_DISCONNECT_DELAY_MS = 5000;
export const RECOVERY_CHECK_INTERVAL_MS = 5000;
/**
 * Max number of consecutive websocket recovery cycles before we give up and stay
 * on the fallback source permanently. Without this ceiling the recovery loop
 * retries forever, spamming the console when the websocket server is unreachable.
 * The counter is reset on a successful connection or when the tab is refocused.
 */
export const MAX_RECOVERY_ATTEMPTS = 3;
